/**
 * Redux store - single source of truth
 */
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import merchantsReducer from './slices/merchantsSlice';
import leadsReducer from './slices/leadsSlice';
import dashboardReducer from './slices/dashboardSlice';
import issueReducer from './slices/issueSlice';
import userReducer from './slices/userSlice';
import teamsReducer from './slices/teamsSlice';
import lookupReducer from './slices/lookupSlice';
import prospectsReducer from './slices/prospectsSlice';
import meetingsReducer from './slices/meetingsSlice';
import documentsReducer from './slices/documentsSlice';
import equipmentReducer from './slices/equipmentSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    merchants: merchantsReducer,
    equipment: equipmentReducer,
    leads: leadsReducer,
    dashboard: dashboardReducer,
    issues: issueReducer,
    users: userReducer,
    teams: teamsReducer,
    lookup: lookupReducer,
    prospects: prospectsReducer,
    meetings: meetingsReducer,
    documents: documentsReducer,
  },
});
